module.exports = __webpack_public_path__ + "static/moreBg.5edacf0e.png";